import { ChangeAlertCallbackType } from "../components/Root";
import { getPosition } from "./PositionService";
import * as API from '../http/api';

export class FraudService {
    private changeAlert: ChangeAlertCallbackType
    constructor(changeAlert: ChangeAlertCallbackType) {
        this.changeAlert = changeAlert
    }
    
    async fraudList(data) {
        const pos = getPosition();
        const response = await API.service('fraudList', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async fraudAdd(data) {
        const pos = getPosition();
        const response = await API.service('fraudAdd', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async fraudUpdate(data) {
        const pos = getPosition();
        const response = await API.service('fraudUpdate', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    // Accumulators
    async fraudAccumulatorGet(data) {
        const pos = getPosition();
        const response = await API.service('fraudAccumulatorGet', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async fraudAccumulatorFind(data) {
        const pos = getPosition();
        const response = await API.service('fraudAccumulatorFind', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async fraudAccumulatorAdd(data) {
        const pos = getPosition();
        const response = await API.service('fraudAccumulatorAdd', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async fraudAccumulatorUpdate(data) {
        const pos = getPosition();
        const response = await API.service('fraudAccumulatorUpdate', data, pos, this.changeAlert, null, null);

        return response?.data
    }

    // Config Accumulators
    async fraudAccConfigGet(data) {
        const pos = getPosition();
        const response = await API.service('fraudAccConfigGet', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async fraudAccConfigFind(data) {
        const pos = getPosition();
        const response = await API.service('fraudAccConfigFind', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async fraudAccConfigAdd(data) {
        const pos = getPosition();
        const response = await API.service('fraudAccConfigAdd', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async fraudAccConfigUpdate(data) {
        const pos = getPosition();
        const response = await API.service('fraudAccConfigUpdate', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async fraudRebootGet(data) {
        const pos = getPosition();
        const response = await API.service('fraudRebootGet', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async fraudRebootFind(data) {
        const pos = getPosition();
        const response = await API.service('fraudRebootFind', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    async fraudRebootUpdate(data) {
        const pos = getPosition();
        const response = await API.service('fraudRebootUpdate', data, pos, this.changeAlert, null, null);

        return response?.data
    }
    
}